import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { IMyleTableColumnOrderPropsv2 } from "@/Common/Components/Tables/MyleTableColumnOrderControlv2";
import { DateHelper } from "@/Common/Helpers/DateHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface BaseImmunizationTableProps<TModel> {
    dataSource: ITableDataSourceItem<TModel>[];
    isReadOnly: boolean;
    onAdd?: () => void;
}

abstract class BaseImmunizationTable<TProps extends BaseImmunizationTableProps<TModel>, TModel> extends BaseReactComponent<TProps, null> {
    protected abstract tableId(): string;
    protected abstract defaultTableOptions(): Immutable.List<MyleTableColumnOptions>;
    protected abstract getTableColumns(tableOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn>;
    protected abstract title(): string;

    private helper = new MyleHelper();

    public render(): JSX.Element {
        const tableRenderOptions = this.loadTableRenderOptions();

        return (
            <div style={{ border: "solid 1px #ccc" }}>
                <div style={{ padding: "10px 15px", backgroundColor: "#f2f5f5" }}>
                    <span>{this.title().toUpperCase()}</span>
                    {this.props.onAdd && !this.props.isReadOnly && (
                        <span style={{ marginLeft: "30px" }}>
                            <a onClick={() => this.props.onAdd()}>[+]</a>
                        </span>
                    )}
                </div>
                <MyleTable
                    TableRenderOptions={tableRenderOptions}
                    TableId={this.tableId()}
                    Columns={this.getTableColumns(this.defaultTableOptions())}
                    DataSource={Immutable.List(this.props.dataSource)}
                    ColumnsPreferencesChangedOperation={ServerOperations.Server.Myle_UpdateUserSettings}
                    NoScrollLimit
                    HideFooter
                />
            </div>
        );
    }

    private loadTableRenderOptions(): ITableRenderOptions {
        let defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: this.defaultTableOptions().filter(x => x.IsHidden === false).map(i => i.WidthPercentageDefault),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: false,
            Autoresize: true,
            OnColumnWidthChange: null,
            HeightOffset: 38
        };

        return Immutable.fromJS(defaultTablePluginOptions);
    }

    public getTableProps(): IMyleTableColumnOrderPropsv2 {
        return {
            TableColumns: this.helper.castColumnConfigurationToMyleTableColumnOptions(this.defaultTableOptions().toArray()),
            SaveOptionskeyTarget: null,
            centeredHorizontally: true,
            ContainerId: `column-order-control-settings-${this.tableId()}`,
            altStyles: { marginLeft: "auto", position: "fixed" }
        };
    }

    protected formatDate(date: string | Date): string {
        return DateHelper.formatDate(date, "YYYY/MM/DD");
    }
}

export { BaseImmunizationTable, BaseImmunizationTableProps };
